import React, {useEffect, useState} from "react";
import {cloneDeep} from "lodash";
import {arrayIncludeItem} from "@app/utils/CommonUtils";
import Select from "react-select";
import {SavedListTabOptions} from "@pages/savedlist/common/Constant";
import {ConnectCddEmpTabs} from "@pages/email/template/dvtjcuv/DVTJCUVTemplateListManager";

const InitSearchConditions = {
    'name': '',
    'note': '',
    'cdd_id': '',
    'cdd_first_name': '',
    'cdd_last_name': '',
    'cdd_displayed_company': '',
    'cdd_displayed_title': '',
}

const QuickSearchMailTemplateList = (props) => {
    const [searchConditions, setSearchConditions] = useState(cloneDeep(InitSearchConditions));
    const [searching, isSearching] = useState(false);
    const [currentTabId, setCurrentTabId] = useState("");

    const {tabId, onSearch} = props

    useEffect(() => {
        if (tabId) {
            setCurrentTabId(tabId)
        }
    }, [tabId])

    const onAddIndustryFunctionItem = (fieldName, value) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(searchConditions[fieldName])
        if (!arr) {
            arr = []
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            searchConditions[fieldName] = arr
            setSearchConditions({...searchConditions})
        }
    }
    const onChangeSearchItem = (name, values) => {
        searchConditions[name] = values;
        setSearchConditions({...searchConditions});
    };

    const onSearchJobs = () => {
        return onSearch(searchConditions)
    }

    const onClearSearchCondition = () => {
        setSearchConditions(cloneDeep(InitSearchConditions));
    }

    return (
        <div className="card card-default">
            <div className="card-header">
                <h3 className="card-title text-bold">Search</h3>
                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                    <i className="fas fa-minus"/>
                </button>
                <div className="card-tools pr-2">
                    <button
                        type='button'
                        className='btn btn-default mr-3'
                        onClick={() => onClearSearchCondition()}
                    >
                        {'Clear'}
                    </button>
                    <button
                        type='button'
                        className='btn btn-primary'
                        onClick={() => onSearchJobs()}
                        disabled={searching}
                    >
                        {searching ? 'Searching...' : 'Search'}
                    </button>
                </div>
            </div>
            <div className="card-body">
                {currentTabId !== ConnectCddEmpTabs.INVITE_CDD_BRIEF_TABLE_TAB.id &&
                <div className={"row"}>
                    <div className='col-sm-6'>
                        <div className='form-group'>
                            <label className={'w-100'}>Tên template</label>
                            <input type='text' className='form-control' placeholder='Tên template'
                                   value={searchConditions.name}
                                   name={'name'}
                                   onChange={event => onChangeSearchItem('name', event.target.value)}/>
                        </div>
                    </div>
                    <div className='col-sm-6'>
                        <div className='form-group'>
                            <label className={'w-100'}>Note</label>
                            <input type='text' className='form-control' placeholder='Note'
                                   value={searchConditions.note}
                                   name={'note'}
                                   onChange={event => onChangeSearchItem('note', event.target.value)}/>
                        </div>
                    </div>
                </div>
                }
                {currentTabId === ConnectCddEmpTabs.INVITE_CDD_BRIEF_TABLE_TAB.id &&
                <div className={"row"}>
                    <div className='col-sm-6'>
                        <div className='form-group'>
                            <label className={'w-100'}>Cdd ID</label>
                            <input type='text' className='form-control' placeholder='Cdd ID'
                                   value={searchConditions.cdd_id}
                                   name={'cdd_id'}
                                   onChange={event => onChangeSearchItem('cdd_id', event.target.value)}/>
                        </div>
                    </div>
                    <div className='col-sm-6'>
                        <div className='form-group'>
                            <label className={'w-100'}>Họ</label>
                            <input type='text' className='form-control' placeholder='Họ'
                                   value={searchConditions.cdd_last_name}
                                   name={'last_name'}
                                   onChange={event => onChangeSearchItem('last_name', event.target.value)}/>
                        </div>
                    </div>
                    <div className='col-sm-6'>
                        <div className='form-group'>
                            <label className={'w-100'}>Tên</label>
                            <input type='text' className='form-control' placeholder='Tên'
                                   value={searchConditions.first_name}
                                   name={'first_name'}
                                   onChange={event => onChangeSearchItem('first_name', event.target.value)}/>
                        </div>
                    </div>
                    <div className='col-sm-6'>
                        <div className='form-group'>
                            <label className={'w-100'}>Displayed Company</label>
                            <input type='text' className='form-control' placeholder='Displayed Company'
                                   value={searchConditions.displayed_company}
                                   name={'first_name'}
                                   onChange={event => onChangeSearchItem('displayed_company', event.target.value)}/>
                        </div>
                    </div>
                    <div className='col-sm-6'>
                        <div className='form-group'>
                            <label className={'w-100'}>Displayed Title</label>
                            <input type='text' className='form-control' placeholder='Displayed Title'
                                   value={searchConditions.displayed_title}
                                   name={'displayed_title'}
                                   onChange={event => onChangeSearchItem('displayed_title', event.target.value)}/>
                        </div>
                    </div>
                    <div className='col-sm-6'>
                        <div className='form-group'>
                            <label className={'w-100'}>Note</label>
                            <input type='text' className='form-control' placeholder='Note'
                                   value={searchConditions.note}
                                   name={'note'}
                                   onChange={event => onChangeSearchItem('note', event.target.value)}/>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    )
}

export default QuickSearchMailTemplateList;
